import { I18N_RESOURCES } from '@/localization';
import { ISelectItem } from '@/models/select';

type I18nResource = keyof typeof I18N_RESOURCES;
export type LocalizationTitle = keyof (typeof I18N_RESOURCES)['en']['localization'];

const locales: Record<I18nResource, LocalizationTitle> = {
  en: 'english',
  it: 'italian',
} as const;

export const LOCALIZATION_OPTIONS: ISelectItem[] = Object.entries(locales).map(([key, value]) => ({
  id: key,
  label: value,
}));
